import React from 'react'
import PropTypes from 'prop-types'

const SurveyQuestion = props => {
  const { id, children } = props

  return (
    <div className='survey-question-wrapper' id={id}>
      {children}
    </div>
  )
}

SurveyQuestion.propTypes = {
  id: PropTypes.string
}
export default SurveyQuestion
